export enum IdentificationType{
    ID_NUMBER="ID_NUMBER",
    PASSPORT="PASSPORT"
}